export const paymentTypeLabel = value => ({
  LivingAllowance: 'Living allowance', TuitionFeesDirect: 'Tuition fees (direct)',
  TuitionFeesReimbursement: 'Tuition reimbursement', Transportation: 'Transportation',
}[value] || String(value || 'Payment').replace(/([a-z])([A-Z])/g, '$1 $2'));

export function buildInterventionPaymentSummary(funding, lines) {
  const active = lines.filter(line => line.status !== 'cancelled' && line.packetStatus !== 'cancelled');
  const usage = new Map(funding.map(line => [String(line.id), 0]));
  let unmatched = false;
  for (const line of active) {
    // Stable approved-line identity takes precedence; never guess between duplicate supports.
    let candidates = line.costLineId
      ? funding.filter(item => String(item.id) === String(line.costLineId))
      : funding.filter(item => item.paymentType === line.paymentType && item.payeeName === line.payeeName);
    if (!line.costLineId && candidates.length > 1 && line.costLineIndex) {
      candidates = candidates.filter(item => funding.indexOf(item) + 1 === Number(line.costLineIndex));
    }
    if (candidates.length !== 1) { unmatched = true; continue; }
    const key = String(candidates[0].id);
    usage.set(key, usage.get(key) + Math.round(Number(line.amount || 0) * 100));
  }
  const groups = new Map();
  for (const line of active) {
    const id = String(line.packetId);
    if (!groups.has(id)) groups.set(id, { id, status: line.packetStatus, dueBy: line.packetDueBy || line.dueBy, amount: 0, lines: [] });
    const packet = groups.get(id);
    packet.amount += Math.round(Number(line.amount || 0) * 100);
    packet.lines.push(line);
  }
  return {
    funding: funding.map(line => ({ ...line, included: unmatched ? null : usage.get(String(line.id)) / 100,
      remaining: unmatched || line.approvedAmount === null ? null : (Math.round(line.approvedAmount * 100) - usage.get(String(line.id))) / 100 })),
    packets: [...groups.values()].map(p => ({ ...p, amount: p.amount / 100 })).sort((a, b) => (a.dueBy || '9999').localeCompare(b.dueBy || '9999') || Number(a.id) - Number(b.id)),
    unmatched,
  };
}
